/* eslint-disable eqeqeq */
import React from "react";
import { useNavigate } from "react-router-dom";

const ItemBody18 = ({ notification }) => {
  const navigate = useNavigate();

  return (
    <div>
      <p className="font-poppins text-xs font-light">
        <span className="text-primary font-medium">
          {notification?.metaData?.driverName}
        </span>{" "}
        <span className="capitalize">({notification?.metaData?.hubName})</span>{" "}
        is requesting batteries to complete their rental trip. Do you want to
        accept?
      </p>

      {/* if action is performed, do not show the button */}
      {notification?.metaData?.action == 1 ? null : (
        <div className="mt-1 w-full flex items-center gap-x-2">
          <button
            type="button"
            className="bg-primary hover:bg-primary-50 py-2 px-4 rounded-md w-full"
            onClick={() => navigate("/request-batteries")}
          >
            <p className="font-poppins text-xs font-medium text-background-white text-center">
              View Details
            </p>
          </button>
        </div>
      )}
    </div>
  );
};

export default ItemBody18;
